import { hasRole } from "@/lib/utils/hasRole";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";

/** Role, które bez agreements_documents_read widzą dokumenty umów obcokrajowców (ASMMNT-80) */
const ROLES_WITH_FOREIGNER_DOCUMENTS_ACCESS = [
  SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE,
  SYSTEM_ROLE_CODE.REGIONAL_DIRECTOR,
] as const;

/**
 * Nazwa obywatelstwa polskiego w słowniku `asm.citizenships`. Słownik nie ma kodu ISO,
 * a ULID wpisu różni się między środowiskami, więc porównujemy po nazwie.
 */
const POLISH_CITIZENSHIP_NAME = "polskie";

interface AgreementDocumentsAccessInput {
  /** Czy użytkownik ma uprawnienie agreements_documents_read */
  hasDocumentsReadPermission: boolean;
  /** Kod roli systemowej zalogowanego (lub impersonowanego) użytkownika */
  roleCode?: string;
  /** Nazwa obywatelstwa z zatwierdzonego kwestionariusza (non_draft), z którego powstają PDF-y */
  citizenshipName?: string | null;
}

/** Obywatelstwo nieznane (puste) traktujemy jak polskie — wyjątek ma nie otwierać dostępu w ciemno. */
export function isForeignCitizenship(citizenshipName?: string | null): boolean {
  const normalizedName = citizenshipName?.trim().toLowerCase();
  return !!normalizedName && normalizedName !== POLISH_CITIZENSHIP_NAME;
}

/**
 * Czy użytkownik może podglądać i pobierać dokumenty umowy (oświadczenia, umowy, aneksy).
 * PR i DR bez agreements_documents_read dostają dostęp wyłącznie do umów obcokrajowców.
 */
export function canReadAgreementDocuments({
  hasDocumentsReadPermission,
  roleCode,
  citizenshipName,
}: AgreementDocumentsAccessInput): boolean {
  if (hasDocumentsReadPermission) {
    return true;
  }

  return (
    hasRole(roleCode, ROLES_WITH_FOREIGNER_DOCUMENTS_ACCESS) &&
    isForeignCitizenship(citizenshipName)
  );
}
